(() => {
  const pendingHash = window.__anchorScrollHash;
  const skipSelector = '.skip-to-content-link';
  let didPendingScroll = false;

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getTarget = (hash) => {
    if (!hash || hash === '#') return null;

    const id = decodeURIComponent(hash.slice(1));
    if (!id) return null;

    const byId = document.getElementById(id);
    if (byId) return byId;

    try {
      return document.querySelector(`[name="${CSS.escape(id)}"]`);
    } catch {
      return null;
    }
  };

  const getScrollTarget = (element) => element.closest('.shopify-section') || element;

  const getHeaderOffset = () => {
    const header = document.querySelector('header-component');
    if (!(header instanceof HTMLElement) || !header.hasAttribute('sticky')) return 0;

    const fromCss = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
    const measured = header.getBoundingClientRect().height;

    return Math.max(Number.isFinite(fromCss) ? fromCss : 0, measured, 0);
  };

  const getTargetTop = (element) => {
    const target = getScrollTarget(element);
    return window.scrollY + target.getBoundingClientRect().top - getHeaderOffset();
  };

  const scrollToElement = (element, instant = false) => {
    const html = document.documentElement;
    const top = Math.max(0, getTargetTop(element));
    const behavior = instant || prefersReducedMotion() ? 'auto' : 'smooth';

    html.style.scrollPaddingTop = '0px';
    html.style.scrollBehavior = 'auto';

    window.scrollTo({ top, behavior });

    const restoreScrollStyles = () => {
      html.style.scrollPaddingTop = '';
      html.style.scrollBehavior = '';
    };

    if (behavior === 'auto') {
      restoreScrollStyles();
      return;
    }

    setTimeout(restoreScrollStyles, 1000);
  };

  const restoreHash = (hash) => {
    if (!hash || window.location.hash === hash) return;

    history.replaceState(null, '', `${window.location.pathname}${window.location.search}${hash}`);
  };

  const scrollToHash = (hash, instant = false) => {
    const target = getTarget(hash);
    if (!target) return false;

    scrollToElement(target, instant);
    return true;
  };

  const onPendingHash = () => {
    if (!pendingHash || didPendingScroll) return;

    didPendingScroll = true;
    window.__anchorScrollHash = undefined;

    requestAnimationFrame(() => {
      scrollToHash(pendingHash);
      restoreHash(pendingHash);
    });
  };

  if (pendingHash) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onPendingHash, { once: true });
    } else {
      onPendingHash();
    }
  }

  window.addEventListener('load', () => {
    const hash = pendingHash || window.location.hash;
    const target = getTarget(hash);
    if (!target) return;

    const expected = getHeaderOffset();
    const actual = getScrollTarget(target).getBoundingClientRect().top;
    if (Math.abs(actual - expected) <= 2) return;

    scrollToElement(target, true);
  });

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('a[href]');
    if (!link || link.matches(skipSelector) || link.hasAttribute('download')) return;
    if (link.target && link.target !== '_self') return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch {
      return;
    }

    if (url.origin !== window.location.origin || !url.hash) return;

    const samePage = url.pathname === window.location.pathname && url.search === window.location.search;
    if (!samePage) return;

    const target = getTarget(url.hash);
    if (!target) return;

    event.preventDefault();
    history.pushState(null, '', url.hash);
    document.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
    document.querySelectorAll('header-drawer details[open], .menu-drawer-container[open]').forEach((details) => {
      details.open = false;
    });
    scrollToElement(target, prefersReducedMotion());
  });

  window.addEventListener('hashchange', () => {
    const target = getTarget(window.location.hash);
    if (!target) return;

    scrollToElement(target, prefersReducedMotion());
  });

  window.addEventListener('pagereveal', () => {
    if (didPendingScroll) return;

    const hash = pendingHash || window.location.hash;
    if (!hash) return;

    didPendingScroll = true;
    window.__anchorScrollHash = undefined;

    requestAnimationFrame(() => {
      scrollToHash(hash);
      restoreHash(hash);
    });
  });
})();
